import React, {useEffect, useState} from "react";
import PaymentPeriodTable from "../PaymentPeriodTable";
import PaymentControlBar from "../PaymentControlBar";
import PaymentEmpty from "../PaymentEmpty";
import {useDispatch, useSelector} from "react-redux";
import {selectProfileInfo} from "../../../store/selectors/Profile";
import {createPayout, getPayments} from "../../../store/entities/App/App.actions";
import {selectBalance, selectPayments} from "../../../store/selectors/App";
import Helment from '../../Common/Helmet'
import CircularProgress from "@material-ui/core/CircularProgress";

const PaymentsTable = () => {
    const dispatch = useDispatch();
    const profilePayments = useSelector(selectPayments);

    const totalBalance = useSelector(selectBalance);
    
    const [loading, setLoading] = useState(false)
    const isPaymentsList = profilePayments && !!Object.keys(profilePayments).length;

    useEffect( () => {
        getPaymentInfo()
    }, []);

    const getPaymentInfo = async () => {
      setLoading(true);
      await dispatch(getPayments());
      setLoading(false);
    };

    return (
        <>
            {loading ?
                <div className={"statusContainer"}>
                    <CircularProgress/>
                </div> :
                <div className={"pntsPaymentContainer"}>
                    <Helment title={"Payments - TeachOn"}/>
                    {isPaymentsList ? (
                    <>
                        <PaymentControlBar/>
                        <PaymentPeriodTable data={profilePayments}/>
                    </>)
                    :  <PaymentEmpty/>
                    }
                    
                </div>}
        </>
    );
};

export default PaymentsTable;
